export const OrderHotelStatus = {
    Success: 10,
    Pending: 5,
    NewOrder: 0,
    Unpaid: -5,
    Canceled: -10,
    Fail: -20
}